export default __webpack_public_path__ + "static/media/slider1.bf1b4580.jpg";